<template>
  <div class="change-password">
    <div class="change-password__header">
      <h2 class="change-password__title">Введите новый пароль:</h2>
    </div>

    <form>
      <CabTextField
        v-model="password"
        class="change-password__input"
        autocomplete="new-password"
        label="Пароль"
        name="change-password"
        placeholder=" Введите пароль"
        :type="passwordType"
        @input="errorMessage = ''"
      >
        <template #appendedIcon>
          <EyeIcon
            class="login-form__password-icon"
            :is-striked="passwordType == 'password'"
            @click.native="onIconClick"
          />
        </template>
      </CabTextField>

      <CabTextField
        v-model="repeatPassword"
        class="change-password__input"
        autocomplete="new-password"
        label="Подтверждение пароля"
        name="change-password-repeat"
        placeholder=" Введите пароль"
        :type="passwordType"
        :error-message="errorMessage"
        @input="errorMessage = ''"
      >
        <template #appendedIcon>
          <EyeIcon
            class="login-form__password-icon"
            :is-striked="passwordType == 'password'"
            @click.native="onIconClick"
          />
        </template>
      </CabTextField>

      <ButtonWithLoader :is-loading="isLoading" :is-blocked="isBlocked" class="modal__send" @click="changePassword">
        Установить
      </ButtonWithLoader>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/dist/validators.min";

import { AuthService } from "../../services";

import CabTextField from "../../components/common/CabTextField.vue";
import EyeIcon from "../../components/common/EyeIcon.vue";
import ButtonWithLoader from "../../components/common/ButtonWithLoader.vue";

export default {
  name: "ChangePassword",

  components: {
    CabTextField,
    EyeIcon,
    ButtonWithLoader,
  },

  data() {
    return {
      password: "",
      repeatPassword: "",
      isPasswordVisible: false,
      errorMessage: "",
      isLoading: false,
    };
  },

  validations: {
    password: {
      required,
    },
  },

  computed: {
    passwordType() {
      return this.isPasswordVisible ? "text" : "password";
    },

    restoreCode() {
      return this.$route.query["restore-code"];
    },

    isBlocked() {
      return this.$v.$invalid || this.password !== this.repeatPassword;
    },
  },

  methods: {
    onIconClick() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    async changePassword() {
      if (!this.restoreCode) throw new Error("Need a restoration code.");

      this.isLoading = true;

      try {
        await AuthService.changePassword({
          restoreCode: this.restoreCode,
          newPassword: this.password,
        });

        this.$router.push({ name: "PasswordChangeSuccess" });
      } catch (error) {
        const { response } = error;

        this.errorMessage = response.data.error || "Что-то пошло не так, попробуйте позже...";

        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.change-password {
  width: 332px;
  max-width: 96%;

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 28px;
  }

  &__title {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1;
  }

  &__back {
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
  }

  &__instruction {
    margin-bottom: 32px;
    color: $grey-600;
  }

  &__input {
    margin-bottom: 40px;
  }

  &__email-input {
    margin-bottom: 16px;
  }
}
</style>
